import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Customer {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.customer}?${params}`,
        )
    }

    externalCustomerList({ userId, companyId }) {
        return BaseService.get(
            `${APIPath.externalCustomer}/${userId}/ExternalCustomers?companyId=${companyId}`,
        )
    }

    cumulativeReportList() {
        return BaseService.get(`${APIPath.customer}`)
    }

    update(data) {
        return BaseService.post(`${APIPath.updateCustomer}`, data)
    }

    add(data) {
        return BaseService.post(`${APIPath.customer}`, data)
    }

    remove(id) {
        return BaseService.post(`${APIPath.customer}/${id}/remove`)
    }

    getCustomerGroups(companyId) {
        return BaseService.get(`${APIPath.customerGroup}?CompanyId=${companyId}`)
    }

    addCustomerGroup(data) {
        return BaseService.post(`${APIPath.customerGroup}`, data)
    }

    updateCustomerGroup(data) {
        return BaseService.post(`${APIPath.customerGroupUpdate}`, data)
    }

    getCustomerAdditionalInfo(customerId) {
        return BaseService.get(`${APIPath.customerAdditionalInfo}${customerId}`)
    }

    getCustomClients(companyId) {
        return BaseService.get(
            `${APIPath.customClients}?companyId=${companyId}`,
        )
    }

    // Customer Notification APIs
    saveNotification(data) {
        return BaseService.post(`${APIPath.customerNotification}`, data)
    }

    getNotificationByCustomerId(customerId) {
        return BaseService.get(`${APIPath.customerNotificationByCustomerId}${customerId}`)
    }

    deleteNotification(data) {
        return BaseService.post(`${APIPath.customerNotificationDelete}`, data)
    }
}

const CustomerService = new Customer()
Object.freeze(CustomerService)
export { CustomerService }
